import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_HISTORY_RESOURCE_GROUPS = gql(`
  query GetNoiseEventsHistoryResourceGroups($filter: GetPagedNoiseEventsWithClassificationsFilters!, $paging: PagingInput!) {
    facility {
      noiseEvents (filter: $filter, paging: $paging) {
        results {
          id
          noiseEventPolicyOverride {
            resourceGroupId
            override
          }
        }
      }
    }
  }
`);
